import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useFilterConfig } from '../../hooks/useFilterConfig';
import { useFilterChangeHandler } from '../../hooks/useFilterChangeHandler';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SyncDirectionFilter() {
  const params = useSearchParams();
  const {
    SyncDirection
  } = useFilterConfig();
  const handleChange = useFilterChangeHandler({
    filter: SyncDirection
  });
  if (!SyncDirection) return null;
  const syncDirectionValue = params.get(SyncDirection.field);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "eco_syncDirection",
      marginBlockStart: "200",
      children: SyncDirection.label
    }), /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "eco_syncDirection",
      children: [/*#__PURE__*/_jsx(RadioInput, {
        value: "all",
        defaultChecked: !syncDirectionValue,
        onChange: handleChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.app.syncDirection.all"
        })
      }), SyncDirection.options.map(option => /*#__PURE__*/_jsx(RadioInput, {
        value: option.value,
        defaultChecked: syncDirectionValue === option.value,
        onChange: handleChange,
        children: option.text
      }, option.value))]
    })]
  });
}